import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | DMBD 2023" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <h2 id="session1">SS1: Intelligent Data Mining: Techniques and Applications</h2>
          <p className="home-p text-justify">

            Rapid advancements in big data and artificial intelligence technologies have had a profound impact
            on all areas of human society including the economy, management, politics, healthcare, and education.
            Big data analytics employs a variety of artificial intelligence techniques including machine learning,
            deep learning, computational optimization, evolutionary computation, and swarm intelligence.
            The special session aims at presenting the latest developments of the artificial intelligent algorithms
            in data mining, discussing the future direction of developments, and exchanging novel ideas about
            how to overcome the challenges.
            It welcomes the original contributions that provide novel theories, frameworks and applications to algorithms.
            <br></br>
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
              <li>Evolutionary Computation Algorithms, Swarm Intelligence Algorithms for big data;</li>
              <li>Machine learning and statistical methods for big data;</li>
              <li>Feature Selection, Feature Extraction;</li>
              <li>Dimensionality Reduction;</li>
              <li>Data Preprocessing, Regression, Clustering and Classification;</li>
              <li>Future Directions and Challenges in Intelligent Data Mining</li>
              <li>Industrial Challenges in Intelligent Data Mining</li>
              <li>Big Data mining for modeling, visualization, personalization, and recommendation</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot; SS1--Intelligent Data Mining: Techniques and Applications &quot; in your paper.
          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Prof. Ben Niu</td>
                <td className="align-middle">Shenzhen University, China</td>
                <td className="align-middle">Drniuben@gmail.com</td>
              </tr>
              <tr>
                <td className="align-middle">Prof. Hong Wang</td>
                <td className="align-middle">Shenzhen University, China</td>
                <td className="align-middle">ms.hongwang@gmail.com</td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <hr></hr>

          <h2 id="session2">SS2: Efficient Evolutionary Deep Learning</h2>
          <p className="home-p text-justify">
            Evolutionary computation technique has been widely used for addressing various challenging problems due to its powerful global search ability.
            Meanwhile, there are many complex optimisation tasks in the fields of deep learning such as neural architecture search, weight optimisation,
            hyper-parameter search, feature selection, feature construction, etc. Combining evolutionary computation and deep learning, especially employing
            evolutionary computation technique for optimization problems in deep learning, is becoming a popular topic in both evolutionary computation community
            and deep learning community. However, the most prominent problem is that it is very time consuming to evolve a population of deep neural networks
            which involve the training processes. Efficient techniques, such as surrogate models for ranking, are need to be developed to solve the problem.
            This workshop aims to collect original papers that develop efficient methods for evolutionary deep learning. For all the aforementioned, we kindly
            invite the scientific community to contribute to this workshop by submitting novel and original research related but not limited to the following topics.
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
              <li>Neural Architecture Search (NAS)</li>
              <li>Surrogate Model</li>
              <li>Surrogate assistant Relativistic Performance Rank</li>
              <li>Surrogate-Assisted Evolutionary Neural Architecture Search</li>
              <li>Surrogate model for optimisation</li>
              <li>Neural Predictor</li>
              <li>Evaluation strategy</li>
              <li>Performance evaluator for NAS</li>
              <li>Evaluation Ranking</li>
              <li>Surrogate Model for Classification</li>
              <li>Surrogate Model for Rank</li>

              <li>Evolutionary Deep Learning/Evolving Deep Learning</li>
              <li>Evolutionary Deep Neural Networks</li>
              <li>Evolutionary Computation for Deep Neural Networks</li>
              <li>Evolutionary Neural Architecture Search (ENAS)</li>
              <li>Evolving Deep Neural Networks</li>
              <li>Evolving Convolution Neural Networks</li>
              <li>Evolving Generative Adversarial Networks</li>
              <li>Evolutionary Recurrent Neural Network</li>
              <li>Evolutionary Differentiable Neural Architecture Search</li>
              <li>Evolutionary approach to deep learning</li>
              <li>Searching for Activation Functions</li>
              <li>Deep Neuroevolution</li>
              <li>Deep Neural Evolution</li>
              <li>Neural Networks with Evolving Structure</li>
              <li>AutoML</li>
              <li>Multi-objective Neural Architecture Search</li>
              <li>Evolutionary Optimisation of Deep Learning</li>
              <li>Evolutionary Computation for Neural Architecture Search</li>
              <li>Hybridization of Evolutionary Computation and Neural Networks</li>

              <li>Hyper-parameter Tuning with Evolutionary Computation</li>
              <li>Hyper-parameter Optimisation</li>
              <li>Evolutionary Computation for Hyper-parameter Optimisation</li>
              <li>Evolutionary Computation for Automatic Machine Learning</li>
              <li>Evolutionary Transfer Learning</li>
              <li>Differentiable NAS</li>
              <li>Differentiable Architecture Search</li>
              <li>Partially-Connected Neural Architecture Search</li>
              <li>Attention-Based Neural Architecture Search</li>
              <li>Large-scale Optimisation for Evolutionary Deep Learning</li>
              <li>Evolutionary Multi-task Optimisation in Deep Learning</li>
              <li>Self-adaptive Evolutionary NAS</li>
              <li>EvolNAS</li>
              <li>NASNet</li>

              <li>Neuroevolution</li>
              <li>Evolutionary artificial neural networks</li>
              <li>Evolving artificial neural networks</li>
              <li>Evolving neural networks</li>
              <li>Meta learning for Training artificial neural networks</li>
              <li>Metaheuristic for Training Neural Networks</li>
              <li>Evolutionary structuring of artificial neural networks</li>
              <li>Structure optimisation for feed-forward neural networks</li>
              <li>Learning and evolution in neural networks</li>
              <li>Pareto evolutionary neural networks</li>
              <li>Pareto neuro-evolution</li>
              <li>Automated design of artificial neural networks</li>
              <li>Adjusting weights in artificial neural networks</li>
              <li>Hyper-parameter Tuning with Self-adaptive Evolutionary Algorithm</li>
              <li>Evolutionary Computation in Deep Learning for Regression/Clustering/Classification</li>
              <li>Full-space Neural Architecture Search</li>
              <li>Evolving Neural Networks</li>
              <li>Automatic Design of Neural Architectures</li>
              <li>Evolutionary Neural Networks</li>
              <li>Gradient-Based and Evolutionary Learning System</li>

              <li>Feature Selection, Extraction, and Dimensionality Reduction on High-dimensional and Large-scale Data</li>
              <li>Evolutionary Feature Selection and Construction </li>
              <li>Multi-objective Feature Selection/Multi-object classification/ Multi-object clustering</li>
              <li>Multi-task optimisation, Multi-task learning, Meta learning</li>
              <li>Learning Based Optimisation</li>
              <li>Hybridization of Evolutionary Computation and Cost-sensitive Classification/Clustering</li>
              <li>Bi-level Optimisation (BLO)</li>
              <li>Hybridization of Evolutionary Computation and Class-imbalance Classification/Clustering</li>

              <li>Numerical Optimisation/Combination optimisation/ Multi-objective optimisation</li>
              <li>Genetic Algorithm/Genetic Programming/Particle Swarm Optimisation/Ant Colony Optimisation/Artificial Bee Colony/Differential Evolution/Fireworks Algorithm/Brain Storm Optimisation</li>
              <li>Classification/Clustering/Regression</li>
              <li>Machine Learning/Data Mining/Neural Network/Deep Learning/Support Vector Machine/Decision Tree/Deep Neural Network/Convolutional Neural Network/Reinforcement Learning/Ensemble Learning/K-means
                Real-world Applications of Evolutionary Computation and Machine Learning, e.g. Images and Video Sequences/Analysis, Face Recognition, Gene Analysis, Biomarker Detection, Medical Data Analysis, Text mining, Intrusion Detection Systems, Vehicle Routing, Computer Vision, Natural Language Processing, Speech Recognition, etc.</li>

            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot; SS2--Efficient Evolutionary Deep Learning &quot; in your paper.

          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Yu Xue</td>
                <td className="align-middle">Nanjing University of Information Science & Technology,China</td>
                <td className="align-middle">xueyu@nuist.edu.cn</td>
              </tr>
              <tr>
                <td className="align-middle">Bing Xue</td>
                <td className="align-middle">Victoria University of Wellington, New Zealand</td>
                <td className="align-middle">bing.xue@ecs.vuw.ac.nz </td>
              </tr>
              <tr>
                <td className="align-middle">Yong Zhang</td>
                <td className="align-middle">China University of Mining and Technology, China</td>
                <td className="align-middle">yongzh401@126.com </td>
              </tr>
              <tr>
                <td className="align-middle">Ferrante Neri</td>
                <td className="align-middle">University of Surrey, UK</td>
                <td className="align-middle">f.neri@surrey.ac.uk </td>
              </tr>
              <tr>
                <td className="align-middle">Adam Slowik</td>
                <td className="align-middle">Koszalin University of Technology, Poland</td>
                <td className="align-middle">adam.slowik@tu.koszalin.pl </td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <hr></hr>

          <h2 id="session3">SS3: Data Analysis and Security in Mobile Networks</h2>
          <p className="home-p text-justify">
            With the development of 5G networks, the network bottleneck of mobile networks is gradually broken through.
            The intelligent hardware industry, including the Internet of Things, wearable devices, Vehicle-to-everything,
            smart medicine, smart home, etc., will explode, these devices will continue to generate data and transmit
            it to the cloud. Inadequate data management on mobile networks can lead to the leakage of data and user privacy,
            causing incalculable losses to users and enterprises. Therefore, it is necessary to analyze, encrypt, and govern data.
            This special meeting aims to collect the latest progress in data analysis and security. We encourage high-quality original
            research papers and focus on methods to solve data analysis and security problems.
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
              <li>Multimedia and multimodal data analysis</li>
              <li>Machine learning systems for insecure data</li>
              <li>Analysis of multimedia security vulnerability</li>
              <li>Modelling, analysis, and simulation of data</li>
              <li>The recognition method of image forgery </li>
              <li>Blockchain-based scheme for data system</li>
              <li>Data analysis and security issues in computer vision</li>
            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot;SS3--Data analysis and security in mobile networks&quot; in your paper.

          </p>

          <h4>Organizers</h4>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Affiliate</th>
                <th scope="col">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="align-middle">Jiwei Zhang</td>
                <td className="align-middle">Beijing University of Posts and Telecommunications,Beijing</td>
                <td className="align-middle">
                  jwzhang666@bupt.edu.cn</td>
              </tr>
              <tr>
                <td className="align-middle">Ziyu Jia</td>
                <td className="align-middle">Institute of Automation, Chinese Academy of Sciences, Beijing</td>
                <td className="align-middle"> jia.ziyu@outlook.com </td>
              </tr>
              <tr>
                <td className="align-middle">Haoyang Yu</td>
                <td className="align-middle">Beijing University of Posts and Telecommunications, Beijing</td>
                <td className="align-middle"> yuhaoyang@bupt.edu.cn </td>
              </tr>
              <tr>
                <td className="align-middle">Hongtao Yang</td>
                <td className="align-middle">Beijing Polytechnic College, Beijing</td>
                <td className="align-middle"> yanght@bgy.edu.cn </td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <hr></hr>

          <h2 id="session4">SS4: Modeling and Optimization Research of Smart Integrated Energy System</h2>
          <p className="home-p text-justify">
            In recent years, the trend of digitalization and intelligence in the energy industry has become increasingly obvious,
            and the smart integrated energy system, as a new system integrating energy and digital intelligent technology, has a broad market
            space and technological innovation field. However, due to the diverse types of equipment involved in smart integrated energy systems,
            complex changes in energy flows, and difficult to balance different objectives, its planning and design, operation regulation and
            intelligent management have great challenges. This conference focuses on the fields of smart energy system modeling and intelligent
            optimization. It is committed to paying attention to and promoting the innovative development of smart integrated energy systems
            at home and abroad. Top international experts, scholars and engineers will be invited to discuss hot issues related to smart integrated
            energy system with the theme of &quot; Modeling and Optimization Research of Smart Integrated Energy System&quot;, and exchange the
            latest technological research progress and application experience.

            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
              <li>Smart integrated energy system modeling</li>
              <li>Complex system planning and design</li>
              <li>Intelligent regulation and optimization of energy system</li>
              <li>Optimize resources on the user side</li>
              <li>Intelligent management of energy system</li>
              <li>Constrained multi-objective optimization of complex systems</li>
              <li>Intelligent optimization of energy system with integration of data and knowledge</li>

            </ul>

            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot;SS4--Modeling and Optimization Research of Smart Integrated Energy System&quot; in your paper.

            <h4>Organizers</h4>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Affiliate</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">Mengjun Ming</td>
                  <td className="align-middle">National University of Defense Technology</td>
                  <td className="align-middle">
                    mingmengjun11@nudt.edu.cn</td>
                </tr>
                <tr>
                  <td className="align-middle">Rui Wang</td>
                  <td className="align-middle">National University of Defense Technology</td>
                  <td className="align-middle"> ruiwangnudt@gmail.com </td>
                </tr>
                <tr>
                  <td className="align-middle">Kaiwen Li</td>
                  <td className="align-middle">National University of Defense Technology</td>
                  <td className="align-middle"> likaiwen@nudt.edu.cn </td>
                </tr>
                <tr>
                  <td className="align-middle">Wenhua Li</td>
                  <td className="align-middle">National University of Defense Technology</td>
                  <td className="align-middle"> liwenhua@nudt.edu.cn</td>
                </tr>
              </tbody>
            </table>
          </p>

          <br></br>

          <hr></hr>
          <h2 id="session5">SS5: Advances in Big-Model empowered Fintech and Quantitative Investment</h2>
          <p className="home-p text-justify">
            The financial industry is witnessing an unprecedented revolution driven by technological advancements and data-driven methodologies.
            With the emergence of Fintech and the growing demand for sophisticated investment strategies, the integration of big-model approaches has become
            a driving force behind the industry&apos;s evolution. Big models, empowered by artificial intelligence, machine learning, and data analytics, have opened up
            new avenues for financial institutions and investors to make well-informed decisions with superior accuracy and efficiency.The availability of vast
            amounts of financial data, coupled with the ever-increasing computational power, has paved the way for the development of sophisticated predictive
            models and intelligent algorithms. These models can identify patterns, assess risks, optimize portfolios, and generate insights that were once considered
            unattainable. As a result, big-model empowered Fintech and quantitative investment strategies have gained substantial traction, transforming the traditional financial landscape.

            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
<li>Stock Trend Prediction Based on Big Model</li>

<li>Strategy Decision Based on Big Model</li>
              <li>Large-Scale Data Processing and Distributed Computing</li>
              <li>Automation in Fintech with Big Models</li>
              <li>Application of Big Models in Financial Fraud Detection</li>
              <li>Application of Big Models in Financial Market Surveillance Systems</li>
              <li>Deep Learning in High-Frequency Trading</li>
              <li>Financial Sentiment Analysis</li>
              <li>Deep Learning for Multimodal Financial Data</li>
              <li>Financial Time Series Forecasting</li>
              <li>Deep Learning-Based Financial Portfolio Optimization</li>
              <li>Graph Neural Networks for Financial Modeling</li>
              <li>Transfer Learning in the Financial Domain</li>
              <li>AI Applications in Financial Regulation</li>
            </ul>
            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot;SS5--Advances in Big-Model empowered Fintech and Quantitative Investment&quot; in your paper.

            <h4>Organizers</h4>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Affiliate</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">Ying Tan</td>
                  <td className="align-middle">Peking University</td>
                  <td className="align-middle">ytan@pku.edu.cn
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Wenbo Yan</td>
                  <td className="align-middle">Peking University
                  </td>
                  <td className="align-middle">wenboyan@stu.pku.edu.cn</td>
                </tr>
              </tbody>
            </table>
          </p>
          <br></br>

          <hr></hr>
          <h2 id="session6">SS6: Data mining and optimization in data space</h2>
          <p className="home-p text-justify">
          Dataspace is the transformation of cyberspace from &quot;computing centric&quot; to &quot;data centric&quot;, 
          and it is an integrated virtual space built on the Internet and other networks. At present, 
          the scale of data has expanded largely, and different data spaces in application fields are emerging. 
          These data in the data space are continuously used, merged, and mined through sharing, exchanging, and analyzing,
           which enhances the effectiveness of systems and applications. This special session is about the data organization,
            data mining and optimization technologies in the use of data space, including but not limited to the following topics.

            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li>Cross-domain data mining</li>
            <li>Multi-domain data query optimization</li>
            <li>Optimization-based data quality improvement</li>
            <li> Data mining based on trusted sharing and exchange</li>
            <li>Data mining based on federal learning and evolutionary computation</li>
            <li>Data analysis based on the digital object architecture</li>
            <li>Data organization and exchanging technologies</li>
            </ul>
            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot;SS6--Data mining and optimization in data space&quot; in your paper.

            <h4>Organizers</h4>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Affiliate</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">Kun Liu</td>
                  <td className="align-middle">Advanced Institute of Big Data, Beijing</td>
                  <td className="align-middle">liukun@aibd.ac.cn
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Yi Liu</td>
                  <td className="align-middle">Advanced Institute of Big Data, Beijing
                  </td>
                  <td className="align-middle">liuyi@aibd.ac.cn</td>
                </tr>
              </tbody>
            </table>
          </p>
          <br></br>

          <hr></hr>
          <h2 id="session7">SS7: Digital twin and digital transformation methods, technologies and applications</h2>
          <p className="home-p text-justify">
          With the continuous integration and in-depth development of a new generation of information technology such as
           digitalization, networking, and intelligence, it has had a huge impact on industrial manufacturing, enterprise 
           management, and national economic development, and human society has entered a new era of digitalization.
          This session focuses on the latest frontiers of digital twin and digital technology, 
          and studies the basic theories, methods, and technologies of digitalization, 
          as well as specific applications in product design, industrial manufacturing, and enterprise management. 
          It welcomes the original contributions that provide novel methods, technologies and applications on digital twin and digital transformation.
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li> Digitalization and digital twin methods, technologies</li>
<li> Big data distributed collection, governance, analysis and mining and management decision support</li>
<li> Digital modeling of product design, integrated simulation verification, virtualization integration joint testing, virtual and real joint application</li>
<li> Digital processes, methods and key technologies of industrial manufacturing</li>
<li> Evaluation of digital maturity of enterprise management and digital transformation methods</li>
            </ul>
            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot;SS7--Digital twin and digital transformation methods, technologies and applications&quot; in your paper.

            <h4>Organizers</h4>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Affiliate</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">Ye Ling</td>
                  <td className="align-middle">Nanjing Research Institute of Electronic Engineering</td>
                  <td className="align-middle">yeling_zero@163.com
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Zheng Shaoqiu</td>
                  <td className="align-middle">Nanjing Research Institute of Electronic Engineering
                  </td>
                  <td className="align-middle">zhengshaoqiu1214@foxmail.com</td>
                </tr>
                <tr>
                  <td className="align-middle">Wang Fang</td>
                  <td className="align-middle">Nanjing Research Institute of Electronic Engineering
                  </td>
                  <td className="align-middle">caoerzhu@163.com</td>
                </tr>
              </tbody>
            </table>
          </p>
          <br></br>

          <hr></hr>
          <h2 id="session8">SS8:1st International Workshop on Evolutionary Computing for Healthcare</h2>
          <p className="home-p text-justify">
          The 1st International Workshop on Evolutionary Computing for Health Care at DMBD 2023, aims 
to be a forum where researchers, practitioners and industry representatives can present and discuss 
ongoing work and latest research results of meaningful contributes and systems in health care using 
evolutionary computing approaches. With advancement in biomedical imaging, the amount of data 
generated is increasing in biomedical engineering. For example, data can be generated by 
multimodality image techniques, e.g. ranging from Computed Tomography (CT), Magnetic 
Resonance Imaging (MR), Ultrasound, Single Photon Emission Computed Tomography (SPECT), 
and Positron Emission Tomography (PET), to Magnetic Particle Imaging, EE/MEG, Optical 
Microscopy and Tomography, Photo acoustic Tomography, Electron Tomography, and Atomic 
Force Microscopy, etc. This poses a great challenge on how to develop new advanced imaging 
methods and computational models for efficient data processing, analysis and modeling in clinical 
applications and in understanding the underlying biological process. Evolutionary Computing and 
Deep learning is a rapidly advancing field in recent years, in terms of both methodological 
development and practical applications. It allows computational models of multiple processing 
layers to learn and represent data with multiple levels of abstraction. It is able to implicitly capture 
intricate structures of large-scale data and ideally suited to some of the hardware architectures that 
are currently available.
Evolutionary Computing covers a number of nature-inspired computational methodologies, 
mainly , genetic algorithms (GAs), Swarm Intelligence, and their hybridizations for addressing 
real-world problems to which conventional modeling can be useless due to several reasons such 
as complexity, existent of uncertainties, and the stochastic nature of the processes. Given the 
success of evolutionary computing methods and techniques in health care applications, it is 
expected that they can also be applied successfully to solve the medical issues. The focus of this 
workshop is to carry out the research article which could be more focused on to the in health care 
applications, it is expected that they can also be applied successfully to solve the medical issues
based on Evolutionary Computing. In recent years, Evolutionary Computing and its variants has 
been widely used by researchers. This Issue intends to bring new Evolutionary Computing 
algorithm with some Innovative Ideas and find out the core problems in health care applications
and can play a vital role in handling the different aspects of health care.
            <h4>Topics of Interest</h4>
            Topics of interest include, but are not limited to:
            <ul>
            <li>Medical imaging</li>
            <li>Medical text analyses</li>
            <li>Clinical diagnosis and therapy</li>
            <li>Clinical expert systems</li>
            <li>Modeling and simulation of medical processes</li>
            <li>Health care Informatics</li>
            <li>Biomedical imaging and image processing</li>
            <li>Evolutionary Computing for recommendation in healthcare</li>
            <li>Application of deep learning in biomedical engineering</li>
            <li>Transfer learning and multi-task learning</li>
            <li>Joint semantic segmentation, object detection on biomedical images</li>
            <li>Improvising on the computation of a deep network; exploiting parallel computation techniques and GPU Programming</li>
            <li>New model of new structure of convolutional neural network</li>
            <li>Visualization and explainable deep neural network</li>
            </ul>
            <h4>Submission</h4>
            Please follow the DMBD&apos;2023 instruction for authors and submit your paper via the DMBD&apos;2023
            online submission system. Please specify that your paper is for &quot;SS8--1st International Workshop on Evolutionary Computing for healthcare&quot; in your paper.

            <h4>Organizers</h4>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Affiliate</th>
                  <th scope="col">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">Waqas Haider Bangyal</td>
                  <td className="align-middle">Kohsar University Murree, KUM, Murree, Punjab, Pakistan</td>
                  <td className="align-middle">waqas_bangyal@hotmail.com
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Jamil Ahmad</td>
                  <td className="align-middle">Hazara University, KPK, Pakistan
                  </td>
                  <td className="align-middle">jamil@ieee.org</td>
                </tr>
                <tr>
                  <td className="align-middle">Zia UI Qayyum</td>
                  <td className="align-middle">Allama Iqbal Open University, Islamabad, Pakistan
                  </td>
                  <td className="align-middle"></td>
                </tr>
              </tbody>
            </table>
          </p>
          <br></br>

          <hr></hr>
          {/* <h2 id="session1">
            Special Session 1: &quot;Swarm Intelligence and Machine Learning in
            Management Science and Industrial Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <p>
            With the rapid development of computation power and artificial
            intelligence, swarm intelligence and machine learning have attracted
            attention from both researchers and engineers in the field of
            management science, computer engineering, scheduling,
            bioinformatics, data mining, design optimization, etc. Swarm
            intelligence algorithms, inspired by the behavior in self-organized
            groups, such as birds, ants, bacteria, etc., hold the superiority in
            complex optimization problems. Machine learning algorithms, such as
            the reinforcement learning algorithms, have shown strong ability in
            interactive learning environment. How to utilize swarm intelligence
            algorithms and machine learning algorithms to deal with problems in
            management and industrial fields remains to be an interesting topic.{" "}
            <br />
            <br />
            The objective of this special session is to gather recent
            theoretical contributions in swarm intelligence and machine learning
            fields. And it also collects unpublished methods for practical
            problems in management science and industrial applications.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>
                Theoretical contributions in swarm intelligence algorithms:
                particle swarm optimization, bacterial foraging optimization,
                genetic algorithm, hydrogical cycle optimization, grey wolf
                optimization, artificial fish search algorithm, etc;
              </li>
              <li>
                Unpublished ideas in machine learning algorithms: reinforcement
                learning, deep learning, machine learning, meta-learning, etc.;
              </li>
              <li>
                Original work towards multi-objective problems, multi-task
                problems and constrained problems;
              </li>
              <li>
                 Efficient methods for practical problems in management science
                and industrial applications: intelligent transportation, medical
                dispatching, data mining, information systems, robotics,
                recommender systems, image processing, manufacturing system
                scheduling, etc.;
              </li>
              <li>
                Other Intelligent Computing and Swarm Intelligence Related
                Algorithms and Applications.
              </li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2022 instruction for authors and submit your
            paper via the ICSI 2022 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS1&quot; -- the Special Session on Swarm Intelligence and
              Machine Learning in Management Science and Industrial Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Dr. Tianwei Zhou</td>
                <td>Shenzhen University</td>
                <td>tianwei@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Shuang Geng</td>
                <td>Shenzhen University</td>
                <td>gs@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Hong Wang</td>
                <td>Shenzhen University</td>
                <td>ms_hongwang@163.com</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>

          <p align="center">&nbsp;</p>
          <br></br> */}

          {/* <h2 id="session2">
            Special Session 2: &quot;Brain Storm Optimization Algorithm and Its Applications&quot;{" "}
            <p align="center">&nbsp;</p>
          </h2>
          <h3>Overview</h3>
          <p>
            The Brain Storm Optimization (BSO) algorithm is a new kind of swarm
            intelligence algorithm, which is based on the collective behavior of
            human beings, that is, the brainstorming process. There are two
            major operations involved in BSO, i.e., convergent operation and
            divergent operation. A &quto;good enough &quto; solution could be
            obtained through recursive solution divergence and convergence in
            the search space. The designed optimization algorithm will naturally
            have the capability of both convergence and divergence.
            <br />
            <br />
            BSO algorithm possesses two kinds of functionalities: capability
            learning and capacity developing. The divergent operation
            corresponds to the capability of learning while the convergent
            operation corresponds to capacity developing. The capacity
            developing focuses on moving the algorithm&apos;s search to the
            area(s) where higher potential solutions may exist while the
            capability learning focuses on its actual search towards new
            solutions from the current solution for single-point based
            optimization algorithms or the current population of solutions for
            population-based swarm intelligence algorithms. The capability
            learning and capacity developing recycle to move individuals towards
            better and better solutions. The BSO algorithm, therefore, can also
            be called as a developmental brain storm optimization algorithm.
            <br />
            <br />
            The capacity developing is a top-level learning or macro-level
            learning methodology. The capacity developing describes the learning
            ability of an algorithm to adaptively change its parameters,
            structures, and/or its learning potential according to the search
            states of the problem to be solved. In other words, capacity
            developing is the search potential possessed by an algorithm.
            Capability learning is bottom-level learning or micro-level
            learning. The capability learning describes the ability of an
            algorithm to find better solutions from current solutions with the
            learning capacity it possesses.
            <br />
            <br />
            The BSO algorithm can also be seen as a combination of swarm
            intelligence and data mining techniques. Every individual in the
            brain storm optimization algorithm is not only a solution to the
            problem to be optimized, but also a data point to reveal the
            landscapes of the problem. The swarm intelligence and data mining
            techniques can be combined to produce benefits above and beyond what
            either method could achieve alone.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            This special session aims at presenting the latest developments of
            the BSO algorithm, as well as exchanging new ideas and discussing
            the future directions of developmental swarm intelligence. Original
            contributions that provide novel theories, frameworks, and
            applications to algorithms are very welcome for this Special
            session.
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2022 instruction for authors and submit your
            paper via the ICSI 2022 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS2&quot; -- the Special Session on Brain Storm Optimization
              Algorithms
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Gai-Ge Wang</td>
                <td>Ocean University of China</td>
                <td>gaigewang@163.com</td>
              </tr>
              <tr>
                <td>Prof. Lianbo Ma</td>
                <td>Northeastern University</td>
                <td>malb@swc.neu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Shi Cheng</td>
                <td>Shaanxi Normal University</td>
                <td>cheng@snnu.edu.cn </td>
              </tr>
              <tr>
                <td>Prof. Yuhui Shi</td>
                <td>Southern University of Science and Technology</td>
                <td>shiyh@sustech.edu.cn</td>
              </tr>
            </table>
          </p>

          <p align="center">&nbsp;</p>
          <p align="center">&nbsp;</p> */}

          {/* <br></br>
          <hr></hr> */}

          <div className="call-sp">


            <h2 id="callforss">DMBD 2023 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              DMBD 2023 technical program will include special sessions. Their aim is to provide a
              complementary flavor to the regular sessions and should include hot topics of interest
              to
              the swarm intelligence community that may also go beyond disciplines traditionally
              represented at DMBD.
            </p>

            <p align="justify">
              Prospective organizers of special sessions should submit proposals indicating:
              <ul >
                <li>Title of the session.</li>
                <li>Rationale of the need for the special session at DMBD.</li>
                <li>The rationale should stress the novelty of the topic and/or its multidisciplinary
                  flavor, and must explain how it is different from the subjects covered by the
                  regular sessions.</li>
                <li>Short biography of the organizers.</li>
                <li>List of 5 – 6 contributed papers (including titles, authors, contact information of
                  the corresponding author) (this can also be provided later when they become
                  available).</li>
              </ul>
            </p>


            <p align="justify">
              Proposals are due on or before July 31st, 2023 and should be sent via e-mail (in
              either
              pdf
              or plain ASCII text form) to the special sessions chair (to be announced) and forward to
              DMBD 2023 secretariat at dmbd2023@iasei.org.
            </p>

            <p align="justify">

              Proposals will be evaluated based on the timeliness of the topic, the qualifications of
              the
              organizers and the authors of the papers proposed in the session. In its decision, the
              committee will try to realize a balance of the topics across the technical areas
              represented
              in swarm intelligence.

            </p>

            <p align="justify">
              Notification of acceptance will be sent to the organizers no later than October 15th,
              2023.
              Authors of papers included in approved special sessions should submit their manuscript
              on or
              before 	July 31st,2023 . Manuscripts should conform to the formatting and electronic
              submission guidelines of regular DMBD papers (Springer’s CCIS format).
            </p>

            <p align="justify">
              When they submit papers, there is a choice to indicate that their papers are special
              session
              papers which will also undergo peer review. It is the responsibility of the organizers
              to
              ensure that their special session meets the DMBD quality standards. If, at the end of
              the
              review process, less than four papers are accepted, the session will be canceled and the
              accepted papers will be moved to regular sessions.
            </p>


          </div>
          {/* <h2 id="session2">
            Special Session 2: &quot; Competition on Single Objective Bounded Optimization Problems &quot;{" "}
          </h2>
          <p>
          Since optimization problems are widely used in real-world applications, it has always been one of the hot topics in research. With the popularity of machine learning and deep learning, how to efficiently and accurately solve optimization problems has become an urgent problem that needs to be addressed. Among them, the single-objective bounded optimization problem is one of the basic types of all optimization problems. Due to the complexity of modern optimization problems, the optimization of some complex functions is relatively difficult. Decades ago, the emergence of stochastic search algorithms such as evolutionary algorithms and swarm intelligence algorithms makes it possible to find the global optimal solutions of some complex functions. In order to test the performance of numerous evolutionary algorithms and swarm intelligence algorithms, we propose a test suite to complete this task.<br/><br/>
          This special session is devoted to the evolutionary algorithms and swarm intelligence algorithms for solving single-objective bounded optimization. We encourage all researchers to test their algorithms on the ICSI&apos;2022 test suite. This test suite includes 10 black-box test functions which means you do not need to know the exact form of these test functions. This form of benchmark functions is convenient for researchers to design and improve their algorithms, and it is also helpful for improving the generalization of the algorithms.<br/><br/>
          The participants are required to send the final results in the format specified in the technical report to the organizers. The original code of the algorithm also needs to be attached. The organizers will present an overall analysis and comparison based on these results. We will select the algorithms that perform well and give them a certain amount of bonuses. We are encouraging all researchers to test their algorithms on this test suite and take part in our competition.<br/><br/>
          We provide python and MATLAB code for our benchmark functions. All the code is available on <a href="https://github.com/cil-lab/icsi2022">Github</a>. You could check the README file to learn how to use our ICSI&apos;2022 test suite. Read this <a href="https://github.com/cil-lab/icsi2022/blob/main/ICSI_2022_Benchmark_functions.pdf">PDF</a> to understand what information should be submitted in the paper.

          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
		  <ul>
		  
            <li>Swarm intelligence algorithms: Particle swarm optimization, bacterial foraging optimization, grey wolf optimization, artificial fish search algorithm, Bees algorithms, etc;</li>
            <li>Evolutionary algorithms: Genetic Algorithm, differential evolution, evolutionary strategies, etc.;</li>
            <li>Other related heuristic algorithms.</li>
			</ul>

          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2022 instruction for authors and submit your paper via the ICSI 2022 online submission system. Please specify that your paper is for &nbsp;
            <strong>
              &quot;SS2&quot; -- Competition on Single Objective Bounded Optimization Problems
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Prof. Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Tianwei Zhou</td>
                <td>Shenzhen University</td>
                <td>tianwei@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Shuang Geng</td>
                <td>Shenzhen University</td>
                <td>gs@szu.edu.cn</td>
              </tr>
              <tr>
                <td>Dr. Hong Wang</td>
                <td>Shenzhen University</td>
                <td>ms_hongwang@163.com</td>
              </tr>
            </table>
          </p> */}

          {/* <h2 id="ss2">
            Special Session 2: &quot;Swarm Intelligence for Large-scale Discrete
            Optimization Problems&quot;
          </h2>
          <p>
            The discrete optimization problem can be seen everywhere in our
            daily life and attract the attention of a large number of
            practitioners throughout the year. Swarm intelligence (SI) as an
            effective method has been successfully applied to such problems and
            achieved many achievements thanks to its many excellent
            characteristics, such as simplicity, robustness, parallelism, and
            applicability. However, classical SI algorithms are also facing new
            challenges with the rapid increase in the scale of optimization
            problems, which requires more efficient search mechanism. The
            objective of this special session is to gather relevant researchers
            from all over the world and provide a platform for everyone to share
            your experience and exchange the latest ideas.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas relevant to the special issue include, but are not
            limited to, the following topics:
            <li>
              This special session receives all original and unpublished work
              that relates to large-scale discrete optimization problems and SI
              algorithms in both theoretical analysis and engineering
              applications.{" "}
            </li>
            <li>
              Theoretical analysis of the effectiveness of SI algorithms for
              discrete problems.
            </li>
            <li>
              New SI algorithms or search strategies for large-scale discrete
              optimization problems.
            </li>
            <li>
              The mixing of various optimization problems, such as large-scale
              multi-objective problem and large-scale constrained discrete
              problem.
            </li>
            <li>
              New discrete benchmark functions or models derived from real-world
              problems.
            </li>
            <li>
              Applications of SI algorithms to large-scale optimization
              problems, such as scheduling problem, delivery problem, and mixed
              discrete-continuous problem
            </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS2&quot; -- the Special Session on Swarm Intelligence for
              Large-scale Discrete Optimization Problems
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="https://www.eng.niigata-u.ac.jp/~yujun/">
                    Dr. Jun YU
                  </a>
                </td>
                <td>Niigata University</td>
                <td>yujun@ie.niigata-u.ac.jp</td>
              </tr>
              <tr>
                <td>
                  <a href="https://www.u-aizu.ac.jp/~peiyan/">Dr. Yan PEI</a>
                </td>
                <td>University of Aizu</td>
                <td>peiyan@u-aizu.ac.jp</td>
              </tr>
              <tr>
                <td>
                  <a href="http://evocomp.cse.kyutech.ac.jp/">
                    Dr. Kei OHNISHI
                  </a>
                </td>
                <td>Kyushu Institute of Technology</td>
                <td>ohnishi@cse.kyutech.ac.jp</td>
              </tr>
            </table>
          </p>

          <h2 id="ss3">
            Special Session 3: &quot;Firework Algorithms of Large-scale
            Population and Its High Dimensional Optimization Methods&quot;
          </h2>
          <p>
            In the past few years, the research of fireworks algorithms has
            developed a wealth of technologies and applications. However, with
            the development of science and technology, the environment for
            optimization tasks has changed dramatically. On the one hand, the
            objective functions are getting larger and larger in dimension and
            complexity. On the other hand, the parallel capabilities of current
            computing devices are generally far beyond what they were. Both
            aspects show great potential of fireworks algorithms with large
            population.
          </p>
          <p>
            The objective of this special session is to gather illuminating
            works on fireworks algorithms which focus on controlling and scaling
            the fireworks population. And it also collects instructive
            applications of fireworks algorithms on high dimensional
            optimization problems.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas relevant to the special issue include, but are not
            limited to, the following topics:
            <li>
              All effective fireworks algorithms with larger fireworks
              populations (at least more than 10 fireworks).{" "}
            </li>
            <li>
              Theoretical analysis of effectiveness and scalability of fireworks
              algorithms.{" "}
            </li>
            <li>
              New collaboration mechanism for multiple populations (or
              fireworks) in optimization.{" "}
            </li>
            <li>
              New benchmarking methods of high dimensional optimization
              problems.{" "}
            </li>
            <li>
              New technologies or algorithms (based on fireworks algorithm) for
              high dimensional optimization problems.{" "}
            </li>
            <li>
              Successful application of fireworks algorithms on high dimensional
              optimization problems.{" "}
            </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS3&quot; -- the Special Session on Firework Algorithms of
              Large-scale Population and Its High Dimensional Optimization
              Methods
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="https://www.cil.pku.edu.cn">Ying Tan</a>
                </td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Yifeng Li</td>
                <td>Peking University</td>
                <td>liyifeng0039@gmail.com</td>
              </tr>
              <tr>
                <td>Maiyue Chen</td>
                <td>Peking University</td>
                <td>mychen@pku.edu.cn</td>
              </tr>
            </table>
          </p>
          <h2 id="ss4">
            Special Session 4: &quot;Brain Storm Optimization Algorithms&quot;
          </h2>
          <p>
            The Brain Storm Optimization (BSO) algorithm is a new kind of swarm
            intelligence algorithm, which is based on the collective behavior of
            human beings, that is, the brainstorming process. There are two
            major operations involved in BSO, i.e., convergent operation and
            divergent operation. A &quot;good enough&quot; solution could be
            obtained through recursive solution divergence and convergence in
            the search space. The designed optimization algorithm will naturally
            have the capability of both convergence and divergence.
          </p>
          <p>
            BSO algorithm possesses two kinds of functionalities: capability
            learning and capacity developing. The divergent operation
            corresponds to the capability of learning while the convergent
            operation corresponds to capacity developing. The capacity
            developing focuses on moving the algorithm&apos;s search to the
            area(s) where higher potential solutions may exist while the
            capability learning focuses on its actual search towards new
            solutions from the current solution for single-point based
            optimization algorithms or the current population of solutions for
            population-based swarm intelligence algorithms. The capability
            learning and capacity developing recycle to move individuals towards
            better and better solutions. The BSO algorithm, therefore, can also
            be called as a developmental brain storm optimization algorithm.
          </p>
          <p>
            The capacity developing is a top-level learning or macro-level
            learning methodology. The capacity developing describes the learning
            ability of an algorithm to adaptively change its parameters,
            structures, and/or its learning potential according to the search
            states of the problem to be solved. In other words, capacity
            developing is the search potential possessed by an algorithm.
            Capability learning is bottom-level learning or micro-level
            learning. The capability learning describes the ability of an
            algorithm to find better solutions from current solutions with the
            learning capacity it possesses.
          </p>
          <p>
            The BSO algorithm can also be seen as a combination of swarm
            intelligence and data mining techniques. Every individual in the
            brain storm optimization algorithm is not only a solution to the
            problem to be optimized, but also a data point to reveal the
            landscapes of the problem. The swarm intelligence and data mining
            techniques can be combined to produce benefits above and beyond what
            either method could achieve alone.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            This special session aims at presenting the latest developments of
            the BSO algorithm, as well as exchanging new ideas and discussing
            the future directions of developmental swarm intelligence. Original
            contributions that provide novel theories, frameworks, and
            applications to algorithms are very welcome for this Special
            session. Potential topics include, but are not limited to:
            <li>Theoretical aspects of BSO algorithms; </li>
            <li>Analysis and control of BSO parameters;</li>
            <li>
              Parallelized and distributed realizations of BSO algorithms;
            </li>
            <li>BSO for multiple/many-objective optimization;</li>
            <li>BSO for constrained optimization;</li>
            <li>BSO for discrete optimization;</li>
            <li>BSO for large-scale optimization;</li>
            <li>BSO algorithm with data mining techniques;</li>
            <li>BSO in uncertain environments;</li>
            <li>BSO for real-world applications.</li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS4&quot; -- the Special Session on Brain Storm Optimization
              Algorithms
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>Lianbo Ma</td>
                <td>Northeastern University</td>
                <td>malb@swc.neu.edu.cn</td>
              </tr>
              <tr>
                <td>Xiujuan Lei</td>
                <td>Shaanxi Normal University</td>
                <td>xjlei@snnu.edu.cn</td>
              </tr>
              <tr>
                <td>Shi Cheng</td>
                <td>Shaanxi Normal University</td>
                <td>cheng@snnu.edu.cn</td>
              </tr>
            </table>
          </p>
          <h2 id="ss5">
            Special Session 5: &quot;Intelligent Algorithms for Swarm Robotics
            and Multibody System&quot;
          </h2>
          <p>
            Swarm robotics and multibody system are important topics in the
            robotic systems. Many intelligent algorithms, such as particle swarm
            optimization (PSO), ant colony optimization (ACO) and genetic
            algorithm (GA), have been used in robotics field. In recent decades,
            researchers noticed the truth of that ‘Intelligent Algorithms’ will
            be the soul of many systems and even services. From the technical
            point of view, intelligent algorithms have gradually appearing in,
            e.g., computation, modeling, diagnosis, scheduling management,
            optimization of system integration. Although systems employed with
            algorithms for robotics have improved performances, it is still a
            challenge to understand them fully and enhance their intelligence.
            There are many issues yet worth to be studied for intelligent
            algorithms in the fields of swarm robotics and multibody system. All
            of these evoke our research interests.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            The special session aims to collect a series of intelligent
            algorithms on ideas, concepts, and technologies that are used in
            swarm robotics and multibody system. Original researches are very
            welcomed for this session. Potential topics include, but are not
            limited to:
            <li>
              Purely intelligent algorithms research on PSO, ACO, NN, FA, BSO,
              GA, ABC, AIS, and so on with applications in potential
            </li>
            <li>Intelligent algorithms on mobile robotics</li>
            <li>Intelligent algorithms on multi-mobile manipulators</li>
            <li>Intelligent algorithms on underwater vehicles</li>
            <li>Intelligent algorithms for multibody system</li>
            <li>
              Intelligent algorithms for multi-robot environmental perception
            </li>
            <li>Intelligent algorithms for shape recognition </li>
            <li>Intelligent algorithms for multibody dynamics </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS5&quot;-- Intelligent Algorithms for Swarm Robotics and
              Multibody System
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="http://robotics-tongji.org/members/qtang">
                    Qirong Tang
                  </a>
                </td>
                <td>Tongji University</td>
                <td>qirong.tang@tongji.edu.cn</td>
              </tr>
              <tr>
                <td>Hai Huang</td>
                <td>Harbin Engineering University</td>
                <td>Huanghai@hrbeu.edu.cn</td>
              </tr>
            </table>
          </p>
          <h2 id="ss6">
            Special Session 6: &quot;Performance Assessment of Swarm
            Intelligence Algorithms&quot;
          </h2>
          <p>
            Solving hard optimization problems is one of the most important
            research topics due to the countless applications in different
            areas. Since solving such problems is of great importance, numerous
            metaheuristics were developed, many of which belong to the group of
            swarm intelligence (SI) optimization algorithms. In recent decades,
            there has been an explosion in the number of the proposed swarm
            intelligence algorithms most commonly compared to other
            metaheuristics using one statistic such as average or median of a
            selected performance measure which can lead to putting algorithms in
            different rankings even though there are only small differences
            between them. However, providing more insight about SI algorithms
            performances is still an open issue.
          </p>
          <p>
            The focus of this special session is to highlight theoretical and
            empirical research that investigates approaches needed to analyze SI
            algorithms and performance assessment with regard to different
            criteria. The session seeks to bring together researchers from
            around the globe for stimulating a discussion on recent advances in
            SI for providing explanations about algorithms’ performance. We
            invite in particular studies that include benchmarking analyses for
            SI algorithms.
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            <li>
              Data-driven approaches (i.e. machine learning, information theory,
              statistics) for assessing algorithm performance
            </li>
            <li>Comparative studies between state-of-the-art SI algorithms</li>
            <li>Meta-learning</li>
            <li>Operators influence on SI algorithm behavior</li>
            <li>Parameters influence on SI algorithm behavior</li>
            <li>SI algorithm performance prediction</li>
            <li>Taxonomies of SI algorithms</li>
            <li>
              Machine learning for automatic SI algorithm selection and
              configuration
            </li>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2021 instruction for authors and submit your
            paper via the ICSI 2021 online submission system. Please specify
            that your paper is for{" "}
            <strong>
              &quot;SS6&quot;-- Performance Assessment of Swarm Intelligence
              Algorithms
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table frame="void">
              <tr>
                <td>
                  <a href="https://singidunum.ac.rs/profile/etuba">
                    Dr. Eva Tuba
                  </a>
                </td>
                <td>Singidunum University</td>
                <td>etuba@ieee.org</td>
              </tr>
              <tr>
                <td>
                  <a href="http://cs.ijs.si/popovski/">Gorjan Popovski</a>
                </td>
                <td>Jozef Stefan Institute</td>
                <td>gorjan.popovski@ijs.si</td>
              </tr>
              <tr>
                <td>
                  <a href="http://cs.ijs.si/eftimov/">Dr. Tome Eftimov</a>
                </td>
                <td>Jozef Stefan Institute</td>
                <td>tome.eftimov@ijs.si</td>
              </tr>
              <tr>
                <td>
                  <a href="https://singidunum.ac.rs/profile/mtuba">
                    Prof. dr Milan Tuba
                  </a>
                </td>
                <td>Singidunum University,</td>
                <td>tuba@ieee.org</td>
              </tr>
            </table>
          </p> */}
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
